/**
 * 05 §5 lead marker: where a target moving at `vel` will be when a disc thrown
 * *now* (windup `windupS`, flight `speed`) arrives. Pure geometry — the marker is
 * information, not assist: the player still has to put the reticle there.
 */
import type { Vec2 } from '../../../sim/types.js'

export function leadPoint(from: Vec2, target: Vec2, vel: Vec2, speed: number, windupS: number): Vec2 {
  const s = Math.max(1e-3, speed)
  // Fixed-point iteration on t = windup + |target(t) − from| / speed; converges in a few steps
  // whenever the disc is faster than the target, and is clamped so a faster target can't blow up.
  let t = windupS + Math.hypot(target.x - from.x, target.z - from.z) / s
  const tMax = windupS + 4
  for (let i = 0; i < 6; i++) {
    const px = target.x + vel.x * t, pz = target.z + vel.z * t
    const next = windupS + Math.hypot(px - from.x, pz - from.z) / s
    t = Math.min(tMax, Number.isFinite(next) ? next : t)
  }
  return { x: target.x + vel.x * t, z: target.z + vel.z * t }
}
